var _react_refresh_temp_1;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Create from './create';
import ListPolls from './listPolls';
import { store } from '../../store';
const PollsComponent = () => {
    var _a, _b;
    const isAdmin = (_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.is_admin;
    return (_jsxs(_Fragment, { children: [_jsx(ListPolls, {}), isAdmin ? _jsx(Create, {}) : null] }));
};
_react_refresh_temp_1 = PollsComponent;
$RefreshReg$(_react_refresh_temp_1, "PollsComponent");
export default PollsComponent;
